import { render, staticRenderFns } from "./ContribPanel.vue?vue&type=template&id=41bcbb76&scoped=true&"
import script from "./ContribPanel.vue?vue&type=script&lang=js&"
export * from "./ContribPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bcbb76",
  null
  
)

export default component.exports